export const apiBaseUrl = 'https://widget-data.service.elfsight.com/api/';
